import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { NavbarLog } from '../../navbar/NavbarLog';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText } from 'reactstrap';
//import "./Carrera.css";
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

//Rutas de consulta en el backend
const urlInsertarCriterio = ApiUrl + "insertarcriterio" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarCriterios = ApiUrl + "listarcriterios" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

let listaauxiliar = [];
const itemsPerPage = 3;

export default class GestionCriterios extends Component {

    constructor(props) {
        super(props)

        this.state = {
            pagina: 0,
            criterios: [],
            modalReportIngresarCriterio: false,
            //nuevas variables
            listacriterios: [],
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
    }

    handleChangeListarCriterios() {
        axios.get(urlListarCriterios)
            .then(response => {
                listaauxiliar = response.data.data;

                //PAGINACION
                this.state.itemOffset = 0;
                const endOffset = this.state.itemOffset + itemsPerPage;
                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });

                this.setState((state) => {
                    return { itemOffset: state.itemOffset + endOffset }
                });
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        this.handleChangeListarCriterios();
    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        this.setState({ pagina: event.selected });
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            // Importante: lee state en vez de this.state al actualizar.
            return { itemOffset: newOffset }
        });
    }
    //FIN DE PAGINACION

    mostrarModalIngresar = () => {
        this.setState({ id: 0 });
        this.setState({ nombre_criterio: null });
        this.setState({ estado_criterio: null });
        this.setState({ modalReportIngresarCriterio: true });
    }

    mostrarModalModificar = (registro) => {
        $(function () {
            $("#id").val(registro.id_criterio);
            $("#nombre_criterio").val(registro.nombre_criterio);
            $("#estado_criterio").val(registro.estado_criterio);
        });

        this.setState({ id: registro.id_criterio });
        this.setState({ nombre_criterio: registro.nombre_criterio });
        this.setState({ estado_criterio: registro.estado_criterio });
        this.setState({ modalReportIngresarCriterio: true });
    }

    ocultarModalIngresar = () => {
        this.setState({ modalReportIngresarCriterio: false });
    }

    registrarCriterio = () => {

        if (this.state.nombre_criterio != null && this.state.estado_criterio != null) {
            const f = new FormData();
            f.append("id", this.state.id);
            f.append("nombre_criterio", this.state.nombre_criterio);
            f.append("estado_criterio", this.state.estado_criterio);

            axios.post(urlInsertarCriterio, f)
                .then(response => {
                    if (response.data.success === true) {
                        swal({
                            text: "Operación Exitosa!!",
                            icon: "success",
                            button: "Aceptar",
                        });
                        axios.get(urlListarCriterios)
                            .then(respuesta => {
                                listaauxiliar = respuesta.data.data;
                                if (this.state.pageCount == 1) {
                                    this.setState({ itemOffset: 0 });
                                }

                                //PAGINACION
                                const newOffset = (this.state.pagina * itemsPerPage) % listaauxiliar.length;
                                this.setState((state) => {
                                    return { itemOffset: newOffset }
                                });
                                const endOffset = newOffset + itemsPerPage;
                                //const endOffset = (this.state.pageCount * itemsPerPage) % listaauxiliar.length;
                                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                                this.setState({ itemOffset: newOffset });
                            })
                        this.ocultarModalIngresar();
                    }
                })
                .catch(error => {
                    this.setState({ error: "No existe conexión con el servidor" });
                    swal({
                        text: "No existe conexión con el servidor",
                        icon: "error",
                        button: "Aceptar",
                    });
                });
        }
        else {
            swal({
                text: "Ingresar campos requeridos",
                icon: "warning",
                button: "Aceptar",
            });
        }
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas">
                        <i className="fa fa-chart-line bounce-custom fs-5"></i>
                        <b className="mb-0 fw-semibold"> Gestión de Criterios</b>
                    </div>

                    <div className="p-3 rounded-3 mt-3">
                        <h6 className="fw-bold text-center mb-3 text-azul">Reporte de Criterios</h6>

                        <div className="table-responsive">
                            <table className="table table-hover table-sm-custom">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-start text-azul">#</th>
                                        <th className="text-start text-azul">Nombre</th>
                                        <th className="text-center text-azul">Estado</th>
                                        <th className="text-center text-azul">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.currentItems && this.state.currentItems.map((consola) => (
                                        <tr key={consola.id_criterio}>
                                            <td className="text-start text-azul">{consola.id_criterio}</td>
                                            <td className="text-start text-azul">{consola.nombre_criterio}</td>
                                            <td className="text-center">
                                                <span
                                                    className="badge px-2 py-1"
                                                    style={{
                                                        backgroundColor: consola.estado_criterio === "Activo"
                                                            ? "#4C9A82"
                                                            : "#dc3545",
                                                        color: "white",
                                                        borderRadius: "10px",
                                                        fontSize: "0.75rem"
                                                    }}
                                                >
                                                    {consola.estado_criterio}
                                                </span>
                                            </td>
                                            <td className="text-center">
                                                <button
                                                    className="btn btn-outline-primary btn-sm"
                                                    onClick={() => this.mostrarModalModificar(consola)}
                                                    title="Ver/Editar criterio"
                                                    style={{ borderRadius: "10px" }}
                                                >
                                                    <i className="fas fa-clipboard-list"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="d-flex justify-content-center mt-4">
                            <ReactPaginate
                                previousLabel="<"
                                nextLabel=">"
                                pageCount={this.state.pageCount}
                                onPageChange={this.handlePageClick}
                                containerClassName="pagination pagination-sm-custom"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                activeClassName="active"
                                renderOnZeroPageCount={null}
                            />
                        </div>

                        <Modal isOpen={this.state.modalReportIngresarCriterio}>
                            <ModalHeader>Registro de Criterio</ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <div className="mb-3 centrar">
                                        <input type="hidden" name="id" className="id" id="id" value="" />
                                        <label className="form-label text-azul">Nombre:</label>
                                        <input
                                            type="text"
                                            id="nombre_criterio"
                                            name="nombre_criterio"
                                            onChange={this.handleChange}
                                            value={this.state.value}
                                            className="form-control"
                                            autoComplete="off"
                                            required
                                        />
                                        <label className="form-label text-azul">Estado:</label>
                                        <select
                                            className="form-select"
                                            id="estado_criterio"
                                            name="estado_criterio"
                                            value={this.state.value}
                                            onChange={this.handleChange}
                                            autoComplete="off"
                                            required
                                        >
                                            <option value="" selected disabled>Seleccione</option>
                                            <option value="Activo">Activo</option>
                                            <option value="Inactivo">Inactivo</option>
                                        </select>
                                    </div>
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <button type="button" class="btn btn-outline-success" onClick={() => this.registrarCriterio()} > Ingresar</button>
                                <button class="btn btn-outline-danger" onClick={() => this.ocultarModalIngresar()}>Salir</button>
                            </ModalFooter>
                        </Modal>

                        <div className="text-center mt-3">
                                <button
                                    id="agregar"
                                    type="button"
                                    className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                    style={{ borderRadius: "8px", fontSize: "0.85rem" }}
                                    onClick={() => this.mostrarModalIngresar()}
                                >
                                    <i className="fas fa-plus me-1"></i>Registrar
                                </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

